export default __webpack_public_path__ + "static/media/expenseManagementDefault.cd44a0f8.png";